// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReSchemaI18n from "./ReSchemaI18n.bs.jsx";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReSchemaRegExp from "./ReSchemaRegExp.bs.jsx";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function Make(Lenses) {
  let schema = validations => validations.flat();
  let mergeValidators = validations => Stdlib_Array.reduce(validations, [], (rules, param) => {
    let rule = param[0];
    if (rule !== undefined) {
      return rules.concat([param[1](Primitive_option.valFromOption(rule))]);
    } else {
      return rules;
    }
  });
  let custom = (predicate, field) => [{
      TAG: "Custom",
      field: field,
      predicate: predicate
    }];
  let true_ = (error, field) => [{
      TAG: "True",
      field: field,
      error: error
    }];
  let false_ = (error, field) => [{
      TAG: "False",
      field: field,
      error: error
    }];
  let email = (error, field) => [{
      TAG: "Email",
      field: field,
      error: error
    }];
  let nonEmpty = (error, field) => [{
      TAG: "StringNonEmpty",
      field: field,
      error: error
    }];
  let string = (min, minError, max, maxError, field) => mergeValidators([
    [
      min,
      min => ({
        TAG: "StringMin",
        field: field,
        min: min,
        error: minError
      })
    ],
    [
      max,
      max => ({
        TAG: "StringMax",
        field: field,
        max: max,
        error: maxError
      })
    ]
  ]);
  let regExp = (error, matches, field) => [{
      TAG: "StringRegExp",
      field: field,
      matches: matches,
      error: error
    }];
  let float = (min, minError, max, maxError, field) => mergeValidators([
    [
      min,
      min => ({
        TAG: "FloatMin",
        field: field,
        min: min,
        error: minError
      })
    ],
    [
      max,
      max => ({
        TAG: "FloatMax",
        field: field,
        max: max,
        error: maxError
      })
    ]
  ]);
  let int = (min, minError, max, maxError, field) => mergeValidators([
    [
      min,
      min => ({
        TAG: "IntMin",
        field: field,
        min: min,
        error: minError
      })
    ],
    [
      max,
      max => ({
        TAG: "IntMax",
        field: field,
        max: max,
        error: maxError
      })
    ]
  ]);
  let Validation = {
    schema: schema,
    mergeValidators: mergeValidators,
    custom: custom,
    true_: true_,
    false_: false_,
    email: email,
    nonEmpty: nonEmpty,
    string: string,
    regExp: regExp,
    float: float,
    int: int
  };
  let validateField = (validator, values, i18n) => {
    switch (validator.TAG) {
      case "Email" :
        let field = validator.field;
        let value = Lenses.get(values, field);
        return [
          {
            TAG: "Field",
            _0: field
          },
          ReSchemaRegExp.email.test(value) ? "Valid" : ({
              TAG: "Error",
              _0: Stdlib_Option.getOr(validator.error, i18n.email(value))
            })
        ];
      case "NoValidation" :
        return [
          {
            TAG: "Field",
            _0: validator.field
          },
          "Valid"
        ];
      case "StringNonEmpty" :
        let field$1 = validator.field;
        let value$1 = Lenses.get(values, field$1);
        return [
          {
            TAG: "Field",
            _0: field$1
          },
          value$1 === "" ? ({
              TAG: "Error",
              _0: Stdlib_Option.getOr(validator.error, i18n.stringNonEmpty(value$1))
            }) : "Valid"
        ];
      case "StringRegExp" :
        let matches = validator.matches;
        let field$2 = validator.field;
        let value$2 = Lenses.get(values, field$2);
        return [
          {
            TAG: "Field",
            _0: field$2
          },
          new RegExp(matches).test(value$2) ? "Valid" : ({
              TAG: "Error",
              _0: Stdlib_Option.getOr(validator.error, i18n.stringRegExp(value$2, matches))
            })
        ];
      case "StringMin" :
        let min = validator.min;
        let field$3 = validator.field;
        let value$3 = Lenses.get(values, field$3);
        return [
          {
            TAG: "Field",
            _0: field$3
          },
          value$3.length >= min ? "Valid" : ({
              TAG: "Error",
              _0: Stdlib_Option.getOr(validator.error, i18n.stringMin(value$3, min))
            })
        ];
      case "StringMax" :
        let max = validator.max;
        let field$4 = validator.field;
        let value$4 = Lenses.get(values, field$4);
        return [
          {
            TAG: "Field",
            _0: field$4
          },
          value$4.length <= max ? "Valid" : ({
              TAG: "Error",
              _0: Stdlib_Option.getOr(validator.error, i18n.stringMax(value$4, max))
            })
        ];
      case "IntMin" :
        let min$1 = validator.min;
        let field$5 = validator.field;
        let value$5 = Lenses.get(values, field$5);
        return [
          {
            TAG: "Field",
            _0: field$5
          },
          value$5 >= min$1 ? "Valid" : ({
              TAG: "Error",
              _0: Stdlib_Option.getOr(validator.error, i18n.intMin(value$5, min$1))
            })
        ];
      case "IntMax" :
        let max$1 = validator.max;
        let field$6 = validator.field;
        let value$6 = Lenses.get(values, field$6);
        return [
          {
            TAG: "Field",
            _0: field$6
          },
          value$6 <= max$1 ? "Valid" : ({
              TAG: "Error",
              _0: Stdlib_Option.getOr(validator.error, i18n.intMax(value$6, max$1))
            })
        ];
      case "FloatMin" :
        let min$2 = validator.min;
        let field$7 = validator.field;
        let value$7 = Lenses.get(values, field$7);
        return [
          {
            TAG: "Field",
            _0: field$7
          },
          value$7 >= min$2 ? "Valid" : ({
              TAG: "Error",
              _0: Stdlib_Option.getOr(validator.error, i18n.floatMin(value$7, min$2))
            })
        ];
      case "FloatMax" :
        let max$2 = validator.max;
        let field$8 = validator.field;
        let value$8 = Lenses.get(values, field$8);
        return [
          {
            TAG: "Field",
            _0: field$8
          },
          Lenses.get(values, field$8) <= max$2 ? "Valid" : ({
              TAG: "Error",
              _0: Stdlib_Option.getOr(validator.error, i18n.floatMax(value$8, max$2))
            })
        ];
      case "Custom" :
        return [
          {
            TAG: "Field",
            _0: validator.field
          },
          validator.predicate(values)
        ];
      case "True" :
        let field$9 = validator.field;
        let value$9 = Lenses.get(values, field$9);
        return [
          {
            TAG: "Field",
            _0: field$9
          },
          value$9 ? "Valid" : ({
              TAG: "Error",
              _0: Stdlib_Option.getOr(validator.error, i18n.true_())
            })
        ];
      case "False" :
        let field$10 = validator.field;
        let value$10 = Lenses.get(values, field$10);
        return [
          {
            TAG: "Field",
            _0: field$10
          },
          value$10 === false ? "Valid" : ({
              TAG: "Error",
              _0: Stdlib_Option.getOr(validator.error, i18n.false_())
            })
        ];
    }
  };
  let getFieldValidator = (validators, fieldName) => validators.find(validator => Primitive_object.equal({
    TAG: "Field",
    _0: validator.field
  }, fieldName));
  let getFieldValidators = (validators, fieldName) => validators.filter(validator => Primitive_object.equal({
    TAG: "Field",
    _0: validator.field
  }, fieldName));
  let validateOne = (field, values, i18nOpt, schema) => {
    let i18n = i18nOpt !== undefined ? i18nOpt : ReSchemaI18n.default;
    return getFieldValidators(schema, field).map(validator => validateField(validator, values, i18n)).find(validation => {
      let tmp = validation[1];
      if (typeof tmp !== "object") {
        return false;
      } else {
        return tmp.TAG !== "NestedErrors";
      }
    });
  };
  let validateFields = (fields, values, i18n, schema) => fields.map(field => Stdlib_Option.map(getFieldValidator(schema, field), validator => validateField(validator, values, i18n)));
  let validate = (i18nOpt, values, schema) => {
    let i18n = i18nOpt !== undefined ? i18nOpt : ReSchemaI18n.default;
    let validationList = schema.map(validator => validateField(validator, values, i18n));
    let errors = Stdlib_Array.filterMap(validationList, param => {
      let fieldState = param[1];
      if (typeof fieldState !== "object" || fieldState.TAG === "NestedErrors") {
        return;
      } else {
        return [
          param[0],
          fieldState._0
        ];
      }
    });
    if (errors.length !== 0) {
      return {
        TAG: "Errors",
        _0: errors
      };
    } else {
      return "Valid";
    }
  };
  return {
    Validation: Validation,
    validateField: validateField,
    getFieldValidator: getFieldValidator,
    getFieldValidators: getFieldValidators,
    validateOne: validateOne,
    validateFields: validateFields,
    validate: validate
  };
}

export {
  Make,
}
/* No side effect */
